
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return require("private-next-pages/_error.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_error"])
      });
    }
  